import axios, { AxiosResponse } from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import AsyncCacheManager from '../cache/AsyncCacheManager';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.local_sessions;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
    namespace: 'management_api',
    group: 'local_sessions',
    defaultTtl: '2m',
    hashLargeSegments: true,
    emitMeta: true,
});

// /GetLocalSessionById/<int:local_session_id>

export const getLocalSessionById = async (localSessionId: number) => {
    return await cachedApi.get(`/GetLocalSessionById/${localSessionId}`);
    }

// /GetLastLocalSessionByLocalId/<int:local_id>

export const getLastLocalSessionByLocalId = async (localId: number) => {
    return await cachedApi.get(`/GetLastLocalSessionByLocalId/${localId}`);
    }

// /GetActiveLocalSessionByLocalId/<int:local_id>

export const getActiveLocalSessionByLocalId = async (localId: number) => {
    return await cachedApi.get(`/GetActiveLocalSessionByLocalId/${localId}`);
    }

// /StartLocalSession/<int:local_id>/<int:user_id>

export const startLocalSession = async (localId: number, userId: number) => {
    const res = await api.post(`/StartLocalSession/${localId}/${userId}`, {});
    // Clear the ENTIRE app cache (all namespaces/groups) when a session starts
    await AsyncCacheManager.clearAll();
    return res;
    }

// /EndLocalSession/<int:local_session_id>

export const endLocalSession = async (localSessionId: number, skip_session:boolean=false) => {
    const res = await api.post(`/EndLocalSession/${localSessionId}`, {skip_session});
    // Clear the ENTIRE app cache (all namespaces/groups) when a session ends
    await AsyncCacheManager.clearAll();
    return res;
    }

export const getAllPendings = async (localSessionId: number): Promise<AxiosResponse<any>> => {
    // Use direct API call without cache to always get fresh pending data
    return await retryWithBackoff(() =>
        api.get(`/GetAllPendings/${localSessionId}`)
    );
}

// /GetSessionStateSummary/<int:local_session_id>

export const getSessionStateSummary = async (localSessionId: number) => {
    return await cachedApi.get(`/GetSessionStateSummary/${localSessionId}`);
}

// /DeleteClosedSession/<int:local_session_id>

export const deleteClosedSession = async (localSessionId: number) => {
    const res = await api.delete(`/DeleteClosedSession/${localSessionId}`);
    // Clear the ENTIRE app cache (all namespaces/groups) when a session is deleted
    await AsyncCacheManager.clearAll();
    return res;
}


///// ####### SHIFTS LOGIC ######### /////

/** 
 * create_shift_parser = reqparse.RequestParser()
create_shift_parser.add_argument('local_id', type=int, required=True, help='Local ID to identify the active session')
create_shift_parser.add_argument('user_id', type=int, required=True, help='User creating the new shift')
create_shift_parser.add_argument('name', type=str, required=False, help='Optional name for the shift')


@ns.route('/CreateNewShift')
class CreateNewShift(Resource):
    @ns.doc('Create a new shift for the active session')
    @ns.expect(create_shift_parser)
    @jwt_required()
    def post(self):
        """
        Creates a new shift for the active session of a local.
        This will close the current active shift and start a new one.
        """
        args = create_shift_parser.parse_args()
        local_id = args.get('local_id')
        user_id = args.get('user_id')
        shift_name = args.get('name')
        
        # Get the active session
        active_session = LocalSession.query.filter_by(local_id=local_id, active=True).first()
        if not active_session:
            return {'message': 'No hay sesión activa para este local'}, 404
        
        # Use the session helper to access shifts controller
        helper = LocalSessionHelper(active_session.local_session_id, None, None)
        success, data, status = helper.shiftsController.create_new_shift(local_id, user_id, shift_name)
        
        return data, status
 */

export const createNewShift = async (localId: number, userId: number, name?: string, forceWithPendings?: boolean) => {
        const payload: any = { local_id: localId, user_id: userId };
            if (name) payload.name = name;
            if (forceWithPendings) payload.force_with_pendings = true;
            const res = await api.post(`/CreateNewShift`, payload);
            // Clear the ENTIRE app cache (all namespaces/groups) when a shift is created
            await AsyncCacheManager.clearAll();
            return res;
        }

